module.exports = __webpack_public_path__ + "static/media/documentmanagment.af827377.svg";